jQuery(document).ready(function($){
    observeAddToCartButtons(true);
});
export const observeAddToCartButtons = function (timeOut) {

    var target = document.querySelectorAll(".add_to_cart_button:not(.observed), .single_add_to_cart_button:not(.observed)");

    if(target.length == 0 && timeOut == true) {
        //The node we need does not exist yet.
        //Wait 250ms and try again
        window.setTimeout(observeAddToCartButtons, 250);
        return;
    }

    for (var i = 0; i < target.length; i++) {

        target[i].classList.add('observed')

        target[i].addEventListener('click', function (event) {
            event.preventDefault();
            const parentNode = !event.target.classList.contains('add_to_cart_button') && !event.target.classList.contains('single_add_to_cart_button') ? event.target.parentNode : event.target
            const woobt_ids_elements = document.getElementsByName('woobt_ids')
            let additional_products = []

            // woobt support
            if (woobt_ids_elements.length == 1) {
                const woobt_ids_el = woobt_ids_elements[0]
                let additional_products_value = woobt_ids_el.value

                if (woobt_ids_el.value) {
                    let additional_products_values = woobt_ids_el.value.split(',')

                    additional_products_values.forEach((product) => {
                        var additional_product_data = product.split('/')
                        var this_additional_product = {
                            product_id: additional_product_data[0] || null,
                            quantity: additional_product_data[2] || null
                        }
                        additional_products.push(this_additional_product)
                    })

                }

            }

            const data = { 
                'action': 'add_to_cart_custom',
                'product_id': parentNode.dataset.product_id,
                'variation_id': parentNode.dataset.variation_id,
                'additional_products': additional_products,
                'quantity': parentNode.dataset.quantity ? parentNode.dataset.quantity : 0
            }

            jQuery.ajax({
                url: wc_add_to_cart_params.ajax_url,
                method: 'post',
                data: data,
                beforeSend: function (response) {
                    parentNode.classList.add('loading')
                },
                complete: function (response) {
                    parentNode.classList.remove('loading')
                }, 
                success: function (response) { 
                    if (response.cart_hash ) { 
                        jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash]);
                        jQuery(document.body).trigger('wc_fragment_refresh');

                        // Force refresh fragments, else it won't work on start page etc
                        if(response.fragments) {
                            for (const [key, value] of Object.entries(response.fragments)) {
                                let el = document.querySelector(key)
                                if (el) {
                                    el.outerHTML = value
                                }
                            }
                            
                        }
                        parentNode.classList.add('added')
                        parentNode.classList.add('animate-bounce-once')
                        window.setTimeout(function (parentNode) {
                            parentNode.classList.remove('added')
                            parentNode.classList.remove('animate-bounce-once')
                        }, 2000, parentNode);
                        window.dispatchEvent(new CustomEvent('openminicart'));
                        jQuery( '.woocommerce-error, .woocommerce-message, .woocommerce-info' ).remove();
                    } else {

                        jQuery( '.woocommerce-error, .woocommerce-message, .woocommerce-info' ).remove();
                        jQuery('.woocommerce-notices-wrapper').append(response);

                        return;
                    }
                }
            })
        })        
    }
}